module.exports = __webpack_public_path__ + "static/media/main_400.fb98d9cf.ico";